var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCentralMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#4FAADB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12001_7589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5234 5.11328C15.3594 5.03906 15.1836 5 15 5C14.8164 5 14.6406 5.03906 14.4766 5.11328L7.12109 8.23438C6.26172 8.59766 5.62109 9.44531 5.625 10.4688C5.64453 14.3438 7.23828 21.4336 13.9688 24.6562C14.6211 24.9688 15.3789 24.9688 16.0312 24.6562C22.7617 21.4336 24.3555 14.3438 24.375 10.4688C24.3789 9.44531 23.7383 8.59766 22.8789 8.23438L15.5234 5.11328ZM17.1875 13.125C17.1875 13.9961 16.6758 14.75 15.9375 15.1016V17.8125C15.9375 18.332 15.5195 18.75 15 18.75C14.4805 18.75 14.0625 18.332 14.0625 17.8125V15.1016C13.3242 14.75 12.8125 13.9961 12.8125 13.125C12.8125 11.918 13.793 10.9375 15 10.9375C16.207 10.9375 17.1875 11.918 17.1875 13.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12001_7589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralMap);
export default __webpack_public_path__ + "static/media/central_map.5281a573402f9d60ad84b4549f173814.svg";
export { ForwardRef as ReactComponent };